// import { DialogComponent, DialogOpenEvent, DialogCloseEvent } from '@theme/dialog';
// import { CartAddEvent } from '@theme/events';
// import { isMobileBreakpoint } from '@theme/utilities';

// /**
//  * A custom element that manages a cart drawer.
//  *
//  * @typedef {object} Refs
//  * @property {HTMLDialogElement} dialog - The dialog element.
//  *
//  * @extends {DialogComponent}
//  */
// class CartDrawerComponent extends DialogComponent {
//   /** @type {number} */
//   #summaryThreshold = 0.5;

//   /** @type {AbortController | null} */
//   #historyAbortController = null;

//   connectedCallback() {
//     super.connectedCallback();
//     document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
//     this.addEventListener(DialogOpenEvent.eventName, this.#updateStickyState);
//     this.addEventListener(DialogOpenEvent.eventName, this.#handleHistoryOpen);
//     this.addEventListener(DialogCloseEvent.eventName, this.#handleHistoryClose);

//     if (history.state?.cartDrawerOpen) {
//       history.replaceState(null, '');
//     }
//   }

//   disconnectedCallback() {
//     super.disconnectedCallback();
//     document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
//     this.removeEventListener(DialogOpenEvent.eventName, this.#updateStickyState);
//     this.removeEventListener(DialogOpenEvent.eventName, this.#handleHistoryOpen);
//     this.removeEventListener(DialogCloseEvent.eventName, this.#handleHistoryClose);
//     this.#historyAbortController?.abort();
//   }

//   #handleHistoryOpen = () => {
//     if (!isMobileBreakpoint()) return;

//     if (!history.state?.cartDrawerOpen) {
//       history.pushState({ cartDrawerOpen: true }, '');
//     }

//     this.#historyAbortController = new AbortController();
//     window.addEventListener('popstate', this.#handlePopState, { signal: this.#historyAbortController.signal });
//   };

//   #handleHistoryClose = () => {
//     this.#historyAbortController?.abort();
//     if (history.state?.cartDrawerOpen) {
//       history.back();
//     }
//   };

//   #handlePopState = async () => {
//     if (this.refs.dialog?.open) {
//       this.refs.dialog.style.setProperty('--dialog-drawer-closing-animation', 'none');
//       await this.closeDialog();
//       this.refs.dialog.style.removeProperty('--dialog-drawer-closing-animation');
//     }
//   };

//   #handleCartAdd = () => {
//     if (this.hasAttribute('auto-open')) {
//       this.showDialog();
//     }
//   };

//   open() {
//     this.showDialog();

//     /**
//      * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
//      */
//     customElements.whenDefined('shopify-payment-terms').then(() => {
//       const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
//       const cta = installmentsContent?.querySelector('#shopify-installments-cta');
//       cta?.addEventListener('click', this.closeDialog, { once: true });
//     });
//   }

//   close() {
//     this.closeDialog();
//   }

//   #updateStickyState() {
//     const { dialog } = /** @type {Refs} */ (this.refs);
//     if (!dialog) return;

//     // Refs do not cross nested `*-component` boundaries (e.g., `cart-items-component`), so we query within the dialog.
//     const content = dialog.querySelector('.cart-drawer__content');
//     const summary = dialog.querySelector('.cart-drawer__summary');

//     if (!content || !summary) {
//       // Ensure the dialog doesn't get stuck in "unsticky" mode when summary disappears (e.g., empty cart).
//       dialog.setAttribute('cart-summary-sticky', 'false');
//       return;
//     }

//     const drawerHeight = dialog.getBoundingClientRect().height;
//     const summaryHeight = summary.getBoundingClientRect().height;
//     const ratio = summaryHeight / drawerHeight;
//     dialog.setAttribute('cart-summary-sticky', ratio > this.#summaryThreshold ? 'false' : 'true');
//   }
// }

// if (!customElements.get('cart-drawer-component')) {
//   customElements.define('cart-drawer-component', CartDrawerComponent);
// }


import { DialogComponent, DialogOpenEvent, DialogCloseEvent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';
import { isMobileBreakpoint } from '@theme/utilities';

class CartDrawerComponent extends DialogComponent {
  #summaryThreshold = 0.5;
  #historyAbortController = null;

  connectedCallback() {
    super.connectedCallback();

    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);

    this.addEventListener(DialogOpenEvent.eventName, this.#updateStickyState);
    this.addEventListener(DialogOpenEvent.eventName, this.#handleHistoryOpen);

    // ✅ Load recommendations when drawer opens
    this.addEventListener(DialogOpenEvent.eventName, this.#loadCartRecommendations);

    this.addEventListener(DialogCloseEvent.eventName, this.#handleHistoryClose);

    if (history.state?.cartDrawerOpen) {
      history.replaceState(null, '');
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);

    this.removeEventListener(DialogOpenEvent.eventName, this.#updateStickyState);
    this.removeEventListener(DialogOpenEvent.eventName, this.#handleHistoryOpen);
    this.removeEventListener(DialogOpenEvent.eventName, this.#loadCartRecommendations);
    this.removeEventListener(DialogCloseEvent.eventName, this.#handleHistoryClose);

    this.#historyAbortController?.abort();
  }

  // =========================
  // 🧠 CART RECOMMENDATIONS
  // =========================
  async reloadRecommendations() {
  return this.#loadCartRecommendations();
}

async #loadCartRecommendations() {
    try {
      const container = this.querySelector('#cart-recommendations');
      const grid = this.querySelector('#recommendationsGrid');

      if (!container || !grid) return;

      // Fetch cart
      const res = await fetch('/cart.js');
      const cart = await res.json();

      if (!cart.items || cart.items.length === 0) {
        container.style.display = 'none';
        return;
      }

      // Use last added product
      const lastItem = cart.items[cart.items.length - 1];
      const productId = lastItem.product_id;

      // Fetch recommendations
      const recRes = await fetch(`/recommendations/products.json?product_id=${productId}&limit=6`);
      const data = await recRes.json();

      if (!data.products || data.products.length === 0) {
        container.style.display = 'none';
        return;
      }

      // Show section
      container.style.display = 'block';
      grid.innerHTML = '';

      

data.products.forEach(product => {
  const card = document.createElement('div');
  card.className = 'recommendation-card';

  const price = new Intl.NumberFormat('he-IL', {
    style: 'currency',
    currency: 'ILS',
    trailingZeroDisplay: 'stripIfInteger'
  }).format(product.price / 100);

  // Find first available variant
  const availableVariant =
    product.variants?.find(v => v.available) ||
    product.variants?.[0];

  card.innerHTML = `
    <a href="${product.url}" class="recommendation-link">
      <div class="recommendation-image">
        <img src="${product.featured_image}" alt="${product.title}" />
      </div>

      <div class="recommendation-content">
        <p class="pro-title">${product.title}</p>
        <p class="pro-price">${price}</p>
      </div>
    </a>

    ${
      availableVariant
        ? `
          <button
            class="recommendation-atc button add-to-cart-button button"
            data-variant-id="${availableVariant.id}">
            הוספה לסל
          </button>
        `
        : ''
    }
  `;

  grid.appendChild(card);
});

document.addEventListener('click', async (e) => {
  const btn = e.target.closest('.recommendation-atc');

  if (!btn || btn.disabled) return;

  e.preventDefault();

  const variantId = btn.dataset.variantId;

  if (!variantId) {
    console.error('Variant ID not found');
    return;
  }

  btn.disabled = true;

  const originalText = btn.textContent;
  btn.textContent = 'מוסיף...';

  try {
    // Add product
    const addResponse = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    });

    if (!addResponse.ok) {
      throw new Error('Failed to add product');
    }

    // Get updated cart count
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();

    document.querySelectorAll('.cart-bubble__text-count').forEach((el) => {
      el.textContent = cart.item_count;
    });


    // Get fresh drawer HTML
    const pageResponse = await fetch(window.location.pathname);
    const pageHtml = await pageResponse.text();

    const parser = new DOMParser();
    const doc = parser.parseFromString(pageHtml, 'text/html');

    const currentDrawer = document.querySelector('cart-drawer-component');
    const newDrawer = doc.querySelector('cart-drawer-component');

    if (currentDrawer && newDrawer) {

      // Update header
      const currentHeader = currentDrawer.querySelector('.cart-drawer__header');
      const newHeader = newDrawer.querySelector('.cart-drawer__header');

      if (currentHeader && newHeader) {
        currentHeader.innerHTML = newHeader.innerHTML;
      }

      // Update content
      const currentContent = currentDrawer.querySelector('.cart-drawer__content');
      const newContent = newDrawer.querySelector('.cart-drawer__content');

      if (currentContent && newContent) {
        currentContent.innerHTML = newContent.innerHTML;
        const recommendations = currentContent.querySelector('#cart-recommendations');
        const drawer = document.querySelector('cart-drawer-component');

        if (drawer) {
          await drawer.reloadRecommendations();
        }
      }
    }

    // Update cart count badges
    document.querySelectorAll(
      '.header__cart-count, .cart-count, .cart-count-bubble, [data-cart-count]'
    ).forEach((badge) => {
      badge.textContent = cart.item_count;
    });

    // Keep drawer open
    const drawer =
      document.querySelector('cart-drawer-component') ||
      document.querySelector('.cart-drawer');

    if (drawer) {
      drawer.setAttribute('open', '');
      drawer.classList.add('active');
      drawer.classList.add('is-open');
    }

    document.body.classList.add('overflow-hidden');
    document.body.classList.add('js-drawer-open');

    btn.textContent = 'Added ✓';

    setTimeout(() => {
      btn.textContent = originalText;
    }, 2000);

  } catch (error) {
    console.error(error);

    btn.textContent = 'Error';

    setTimeout(() => {
      btn.textContent = originalText;
    }, 2000);
  } finally {
    btn.disabled = false;
  }
});

      this.#attachAddToCart(grid);
      // ✅ Initialize slider
this.#initSlider(container);

    } catch (err) {
      console.error('Recommendation error:', err);

      const container = this.querySelector('#cart-recommendations');
      if (container) container.style.display = 'none';
    }
  }

  #attachAddToCart(grid) {
    grid.querySelectorAll('button').forEach(btn => {
      btn.addEventListener('click', async () => {
        const variantId = btn.dataset.id;

        try {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 })
          });

          // Refresh cart + recommendations
          document.dispatchEvent(new CustomEvent(CartAddEvent.eventName));

        } catch (err) {
          console.error('Add to cart failed:', err);
        }
      });
    });
  }


  #initSlider(container) {
  const track = container.querySelector('#recommendationsGrid');
  const prevBtn = container.querySelector('.prev');
  const nextBtn = container.querySelector('.next');

  if (!track || !prevBtn || !nextBtn) return;

  let index = 0;

  const getCardWidth = () => {
    const card = track.querySelector('.recommendation-card');
    if (!card) return 0;
    const gap = 12;
    return card.offsetWidth + gap;
  };

  const getVisibleCount = () => {
    const wrapper = container.querySelector('.recommendations-wrapper');
    const cardWidth = getCardWidth();
    return Math.floor(wrapper.offsetWidth / cardWidth) || 1;
  };

  const maxIndex = () => {
    const total = track.children.length;
    const visible = getVisibleCount();
    return Math.max(total - visible, 0);
  };

  const updateSlider = () => {
    const cardWidth = getCardWidth();
    track.style.transform = `translateX(${index * cardWidth}px)`; // RTL
  };

  nextBtn.onclick = () => {
    const step = getVisibleCount(); // 👈 move by visible items
    index = Math.max(index - step, 0);
    updateSlider();
  };

  prevBtn.onclick = () => {
    const step = getVisibleCount();
    index = Math.min(index + step, maxIndex());
    updateSlider();
  };

  // Reset on init
  index = 0;
  updateSlider();
}
  // =========================
  // 🧾 EXISTING LOGIC
  // =========================

  #handleHistoryOpen = () => {
    if (!isMobileBreakpoint()) return;

    if (!history.state?.cartDrawerOpen) {
      history.pushState({ cartDrawerOpen: true }, '');
    }

    this.#historyAbortController = new AbortController();
    window.addEventListener('popstate', this.#handlePopState, {
      signal: this.#historyAbortController.signal
    });
  };

  #handleHistoryClose = () => {
    this.#historyAbortController?.abort();

    if (history.state?.cartDrawerOpen) {
      history.back();
    }
  };

  #handlePopState = async () => {
    if (this.refs.dialog?.open) {
      this.refs.dialog.style.setProperty('--dialog-drawer-closing-animation', 'none');

      await this.closeDialog();

      this.refs.dialog.style.removeProperty('--dialog-drawer-closing-animation');
    }
  };

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }

    // ✅ Reload recommendations after cart update
    this.#loadCartRecommendations();
  };

  open() {
    this.showDialog();

    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }

  #updateStickyState() {
    const { dialog } = this.refs;
    if (!dialog) return;

    const content = dialog.querySelector('.cart-drawer__content');
    const summary = dialog.querySelector('.cart-drawer__summary');

    if (!content || !summary) {
      dialog.setAttribute('cart-summary-sticky', 'false');
      return;
    }

    const drawerHeight = dialog.getBoundingClientRect().height;
    const summaryHeight = summary.getBoundingClientRect().height;
    const ratio = summaryHeight / drawerHeight;

    dialog.setAttribute(
      'cart-summary-sticky',
      ratio > this.#summaryThreshold ? 'false' : 'true'
    );
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}